module.exports = __webpack_public_path__ + "static/media/service1.41f4b679.svg";